import styled from '@independent-software/typeui/styles/Theme'

const BottomBar = styled.div`
  display: flex;
  z-index: 100;
  justify-content: space-between;
  box-shadow: rgba(34, 36, 38, 0.15) 0px 0px 4px 0px;
  padding: 16px 20px 16px 20px;  
  background: #fdfdfd;
`

export { BottomBar }
